export default "/fonts/zenloop-regular-webfont.ttf?de0b1fbcbaee4f043e1820b380449831";